// toastSlice.ts
import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

type ToastSeverity = 'success' | 'error' | 'warning' | 'info';

interface ToastItem {
  id: number;
  message: string;
  severity: ToastSeverity;
  duration: number;
}

interface ToastState {
  toasts: ToastItem[];
  counter: number;
}

const initialState: ToastState = {
  toasts: [],
  counter: 0,
};

export const toastSlice = createSlice({
  name: 'toast',
  initialState,
  reducers: {
    showToast: (
      state,
      action: PayloadAction<{ message: string; severity: ToastSeverity; duration?: number }>,
    ) => {
      state.counter += 1;
      state.toasts.push({
        id: state.counter,
        message: action.payload.message,
        severity: action.payload.severity,
        duration: action.payload.duration ?? 4000,
      });
    },
    hideToast: (state, action: PayloadAction<number>) => {
      state.toasts = state.toasts.filter(t => t.id !== action.payload);
    },
  },
});

export const { showToast, hideToast } = toastSlice.actions;
export default toastSlice.reducer;
